/**
 * AuiChartCard — Title/description card wrapper for charts.
 *
 * Wraps child chart nodes in a Card with a header. Follows the
 * shadcn-echarts demo ChartCard pattern.
 *
 * Props:
 *   title       — card heading
 *   description — optional subheading
 */

import type { ReactNode } from 'react';
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from '@/components/ui/card';
import type { AuiRendererProps } from '../../registry';

export function AuiChartCard({ node, children }: AuiRendererProps) {
  const props = node.component.props ?? {};
  const title = (props.title as string) ?? '';
  const description = props.description as string | undefined;

  return (
    <Card padding="none" className="flex min-w-0 flex-1 flex-col shadow-none" data-testid="aui-chart-card">
      <CardHeader className="flex flex-row items-center justify-between pb-2">
        <div className="space-y-1">
          <CardTitle className="text-base font-semibold">{title}</CardTitle>
          {description && (
            <CardDescription className="text-sm">{description}</CardDescription>
          )}
        </div>
      </CardHeader>
      <CardContent className="flex-1 pb-4">
        {children as ReactNode}
      </CardContent>
    </Card>
  );
}
